import { useEffect, useState } from "react";
import { apiClient, ApiError } from "../lib/apiClient";

export type JsonType = Record<string, unknown>;

export default function useFetch(url: string | null) {
  const [data, setData] = useState<JsonType | null>(null);
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!url) {
      setData(null);
      setError(null);
      return;
    }

    setIsPending(true);
    setError(null);

    apiClient
      .getData<JsonType>(url)
      .then((data) => {
        setData(data);
        setError(null);
      })
      .catch((error: ApiError) => {
        console.error("useFetch error:", error);
        setError(error.message || "An error occurred while fetching data");
        setData(null);
      })
      .finally(() => {
        setIsPending(false);
      });
  }, [url]);

  return { data, isPending, error };
}
